import { useState } from 'react';
import user from '../helpers/user';
import { getBaseSubscription } from '@intigral/utils/lib/user';
import { USER_SEGMENT } from '@intigral/constant/common';

function useShowUpgradeBanner() {
    const [showUpgradedBanner, setShowUpgradedBanner] = useState(false);
    const { operator: userOperator, subscriptionGUID: userSubscriptionGuids, tierStatus } = user.getUserInfo() || {};
    const checkShowUpgradedBanner = (allowedOperaters, allowedGuids) => {
        const userInfo = user.getUserInfo();
        if (userInfo?.segment?.toUpperCase() === USER_SEGMENT.B2C) {
            // sometimes tierStatus is []
            const tierStatus = userInfo?.tierStatus?.tierGuid ? userInfo?.tierStatus : getBaseSubscription(userInfo);
            if (!tierStatus?.active) {
                setShowUpgradedBanner(true);
            } else {
                setShowUpgradedBanner(
                    allowedGuids?.some((item) => userSubscriptionGuids?.includes(item)) &&
                        allowedOperaters?.includes(userOperator)
                );
            }
        }
    };
    return { showUpgradedBanner, checkShowUpgradedBanner };
}
export default useShowUpgradeBanner;
